'use strict';

import { view } from '@/functions';
const prefix = '/timelines';

export default [
    {
        path: prefix,
        name: 'timelines',
        meta: {
            title: 'Timelines',
            scopes: ['read_timelines', 'write_timelines'],
        },
        component: () => view('timelines/index'),
    },
]
